import { render, staticRenderFns } from "./manageProducts.vue?vue&type=template&id=86130068"
import script from "./manageProducts.vue?vue&type=script&lang=js"
export * from "./manageProducts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports